var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useEffect, useRef } from 'react';
import { useForceRender } from '../shared';
import { isArr, isPlainObj, pick } from '@ecom-zform/shared';
export function useFormState(form) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    var type = isPlainObj(params[0])
        ? undefined
        : params[0];
    var options = isPlainObj(params[0])
        ? params[0]
        : isPlainObj(params[1])
            ? params[1]
            : {};
    var render = useForceRender();
    var getState = function () {
        return options.withAllChildren
            ? form.getStateWithAllChildren(type)
            : type
                ? isArr(type)
                    ? pick(form.state, type)
                    : form.state[type]
                : form.state;
    };
    var state = useRef(getState());
    useEffect(function () {
        state.current = getState();
        render();
        var params = [
            type,
            function (newState) {
                state.current = newState;
                render();
            },
            options,
        ];
        // @ts-ignore
        var stop = form.watchState.apply(form, __spreadArray([], __read(params)));
        return function () {
            stop();
        };
    }, __spreadArray([form.uuid, options.sync, options.withAllChildren], [isArr(type) ? undefined : type]));
    return state.current;
}
